import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  getGroups(config) {
    return axiosInstance.get('/master/group_company', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  getGroupById(params) {
    return axiosInstance.get('/master/group_company', {
      params,
      cancelToken: getNewCancelToken(),
    });
  },
  getAll(params) {
    return axiosInstance.get('/master/group_company', {
      params,
      cancelToken: getNewCancelToken(),
    });
  },
  getById(groupId) {
    return axiosInstance.get(`/master/group_company/${groupId}`, {
      cancelToken: getNewCancelToken(),
    });
  },
  create(data) {
    return axiosInstance.post('/master/group_company', data, {
      cancelToken: getNewCancelToken(),
    });
  },
  update(groupId, data) {
    return axiosInstance.put(`/master/group_company/${groupId}`, data, {
      cancelToken: getNewCancelToken(),
    });
  },
  delete(groupId) {
    return axiosInstance.delete(`/master/group_company/${groupId}`, {
      cancelToken: getNewCancelToken(),
    });
  },
};
